import { render, staticRenderFns } from "./NotificationRecurringOrderProductNotEnoughStockModal.vue?vue&type=template&id=3022fe94&"
import script from "./NotificationRecurringOrderProductNotEnoughStockModal.vue?vue&type=script&lang=js&"
export * from "./NotificationRecurringOrderProductNotEnoughStockModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports